module.exports = __webpack_public_path__ + "static/media/simplonbp-light-webfont.5b7fafb1.eot";